import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "hi", label: "हि", name: "हिंदी (Hindi)" },
  { code: "pa", label: "ਪੰ", name: "ਪੰਜਾਬੀ (Punjabi)" },
];

// UI string translations. AI-generated content is translated server-side.
const STRINGS = {
  en: {
    login: "Login", get_started: "Get Started", logout: "Logout",
    dashboard: "Dashboard", assessment: "Assessment", vocational: "Vocational",
    my_children: "My Children", school_overview: "School Overview",
    students: "Students", bulk_upload: "Bulk Upload", class_report: "Class Report",
    school_dashboard: "School Dashboard", admin: "Admin", questions: "Questions",
    results: "Results",
    start_assessment: "Start Assessment", retake_assessment: "Retake Assessment",
    hi_greeting: "Hi", class_: "Class", board: "Board", school: "School",
    take_assessment_title: "Take your career assessment",
    retake_title: "Retake your assessment",
    past_reports: "Past reports", your_history: "Your history",
    no_assessments: "No assessments yet. Take your first one above!",
    what_youll_get: "What you'll get (NEP-aligned)",
    save_pdf: "Save / Print PDF",
    top_careers: "Careers that fit you",
    ai_career_report: "AI Career Report",
    explore_career: "Explore career",
    print_report: "Print / Save PDF",
    recommended_stream: "Recommended stream",
    language: "Language",
    // Landing
    hero_tag: "AI-Powered Career Guidance",
    hero_h1a: "Find the career",
    hero_h1b: "that fits you",
    hero_h1c: "— powered by AI",
    hero_desc: "A friendly psychometric assessment for school students. Answer honest questions on personality, aptitude, interests & mental ability — PathfinderAiClub analyzes it all and reveals your best-fit career paths.",
    hero_cta_primary: "Know Your Best-Fit Career",
    hero_cta_secondary: "I already have an account",
    hero_badge_private: "Private & Secure",
    hero_badge_grades: "Built for Grades 8–12",
    hero_image_caption: "Built for India · CBSE, ICSE, PSEB & State boards",
    nep_kicker: "Why this matters · NEP 2020",
    nep_h2a: "India's National Education Policy asks",
    nep_h2b: "every student to",
    nep_h2c: "choose their own path",
    nep_desc: "NEP 2020 breaks the old rigid Science / Commerce / Arts divide. Students can now mix subjects across streams, take vocational courses from Grade 6, and choose electives that match their strengths and interests. But that freedom needs a compass — and that's exactly what PathfinderAiClub provides.",
    nep_pillar1_t: "Multidisciplinary Learning (§ 4.9)",
    nep_pillar1_d: "Any student, any stream — subjects chosen on ability, not label.",
    nep_pillar2_t: "Vocational Exposure by Grade 6",
    nep_pillar2_d: "Every child gets a real-world skill / internship taste.",
    nep_pillar3_t: "Choice-Based Subjects in 11-12",
    nep_pillar3_d: "Mix Physics with Fine Arts, Biology with Entrepreneurship.",
    nep_pillar4_t: "Multiple Entry / Exit Points",
    nep_pillar4_d: "No single 'wrong' decision — degrees have on-ramps at every stage.",
    nep_how_kicker: "How PathfinderAiClub helps",
    nep_how_desc: "Our AI reads a student's psychometric, aptitude, interest (RIASEC) and mental-ability signals — then produces a report tailored to their class, board (CBSE / ICSE / PSEB / State / IB), and NEP stage. No child gets pushed into a single stream. Instead they see 3 best-fit careers, a subject mix that opens doors, and a Now-Next-Beyond roadmap they can actually follow — with counsellors, parents and principals in the loop.",
    nep_image_caption: "Aligned with the MoE, GoI",
    cats_kicker: "What we measure",
    cats_h2: "4 dimensions. 1 AI report.",
    cat_personality: "Personality",
    cat_personality_d: "Big-Five inspired traits",
    cat_aptitude: "Aptitude",
    cat_aptitude_d: "Logic, verbal & numerical",
    cat_interest: "Interest (RIASEC)",
    cat_interest_d: "What you love doing",
    cat_mental: "Mental Ability",
    cat_mental_d: "Memory & pattern recognition",
    section: "Section",
    how_kicker: "How it works",
    how_h2: "Three simple steps.",
    how1_t: "Answer honestly",
    how1_d: "Take a ~10-minute mixed assessment across 4 dimensions.",
    how2_t: "AI analyzes",
    how2_d: "Our AI reads your patterns and traits to build a personalised path.",
    how3_t: "Get your path",
    how3_d: "Careers, strengths, subjects to pick, and a 3-stage roadmap.",
    partners_kicker: "Our Partners",
    partners_h2: "Trusted by leading institutions",
    footer_copy: "for students, by educators.",
    footer_care: "Made with care",
  },
  hi: {
    login: "लॉगिन", get_started: "शुरू करें", logout: "लॉगआउट",
    dashboard: "डैशबोर्ड", assessment: "मूल्यांकन", vocational: "व्यावसायिक",
    my_children: "मेरे बच्चे", school_overview: "स्कूल सारांश",
    students: "छात्र", bulk_upload: "बल्क अपलोड", class_report: "कक्षा रिपोर्ट",
    school_dashboard: "स्कूल डैशबोर्ड", admin: "एडमिन", questions: "प्रश्न",
    results: "परिणाम",
    start_assessment: "मूल्यांकन शुरू करें", retake_assessment: "फिर से लें",
    hi_greeting: "नमस्ते", class_: "कक्षा", board: "बोर्ड", school: "स्कूल",
    take_assessment_title: "अपना करियर मूल्यांकन लें",
    retake_title: "अपना मूल्यांकन फिर से लें",
    past_reports: "पिछली रिपोर्टें", your_history: "आपका इतिहास",
    no_assessments: "अभी कोई मूल्यांकन नहीं। ऊपर से शुरू करें!",
    what_youll_get: "आपको क्या मिलेगा (NEP-अनुकूल)",
    save_pdf: "PDF सेव करें",
    top_careers: "आपके लिए उपयुक्त करियर",
    ai_career_report: "AI करियर रिपोर्ट",
    explore_career: "करियर देखें",
    print_report: "प्रिंट / PDF",
    recommended_stream: "अनुशंसित स्ट्रीम",
    language: "भाषा",
    // Landing
    hero_tag: "AI-संचालित करियर मार्गदर्शन",
    hero_h1a: "वह करियर खोजें",
    hero_h1b: "जो आपके लिए बना है",
    hero_h1c: "— AI द्वारा संचालित",
    hero_desc: "स्कूली छात्रों के लिए एक मित्रवत साइकोमेट्रिक मूल्यांकन। व्यक्तित्व, योग्यता, रुचि और मानसिक क्षमता पर ईमानदार प्रश्नों का उत्तर दें — PathfinderAiClub का AI इन सबका विश्लेषण करके आपके लिए सबसे उपयुक्त करियर पथ बताता है।",
    hero_cta_primary: "अपना बेस्ट-फिट करियर जानें",
    hero_cta_secondary: "मेरा खाता पहले से है",
    hero_badge_private: "निजी और सुरक्षित",
    hero_badge_grades: "कक्षा 8–12 के लिए",
    hero_image_caption: "भारत के लिए बना · CBSE, ICSE, PSEB और State बोर्ड",
    nep_kicker: "यह क्यों ज़रूरी है · NEP 2020",
    nep_h2a: "भारत की राष्ट्रीय शिक्षा नीति चाहती है कि",
    nep_h2b: "हर छात्र",
    nep_h2c: "अपना रास्ता खुद चुने",
    nep_desc: "NEP 2020 ने विज्ञान / वाणिज्य / कला की पुरानी सख्त सीमाओं को तोड़ दिया है। अब छात्र अलग-अलग स्ट्रीमों के विषय मिलाकर पढ़ सकते हैं, कक्षा 6 से व्यावसायिक कोर्स ले सकते हैं, और अपनी रुचि व शक्ति के अनुसार विषय चुन सकते हैं। लेकिन इस आज़ादी को दिशा देने के लिए एक कम्पास चाहिए — यही PathfinderAiClub देता है।",
    nep_pillar1_t: "बहुविषयक शिक्षा (§ 4.9)",
    nep_pillar1_d: "कोई भी छात्र, कोई भी स्ट्रीम — विषय टैग से नहीं, क्षमता से चुनें।",
    nep_pillar2_t: "कक्षा 6 से व्यावसायिक अनुभव",
    nep_pillar2_d: "हर बच्चे को वास्तविक कौशल या इंटर्नशिप का अनुभव।",
    nep_pillar3_t: "कक्षा 11-12 में चुनाव-आधारित विषय",
    nep_pillar3_d: "भौतिकी के साथ ललित कला, जीवविज्ञान के साथ उद्यमिता।",
    nep_pillar4_t: "एकाधिक प्रवेश / निकास बिंदु",
    nep_pillar4_d: "कोई एक 'ग़लत' फ़ैसला नहीं — हर स्तर पर वापस जुड़ने का रास्ता।",
    nep_how_kicker: "PathfinderAiClub कैसे मदद करता है",
    nep_how_desc: "हमारा AI छात्र के साइकोमेट्रिक, योग्यता, रुचि (RIASEC) और मानसिक क्षमता के संकेतों को पढ़ता है — फिर उसकी कक्षा, बोर्ड (CBSE / ICSE / PSEB / State / IB) और NEP स्तर के अनुसार एक रिपोर्ट तैयार करता है। किसी भी बच्चे को एक स्ट्रीम में धकेला नहीं जाता। इसके बजाय उन्हें 3 सबसे उपयुक्त करियर, दरवाज़े खोलने वाला विषय-मिश्रण, और एक Now-Next-Beyond रोडमैप मिलता है — काउंसलर, माता-पिता और प्रधानाचार्य सब साथ में।",
    nep_image_caption: "शिक्षा मंत्रालय, भारत सरकार से संरेखित",
    cats_kicker: "हम क्या मापते हैं",
    cats_h2: "4 आयाम। 1 AI रिपोर्ट।",
    cat_personality: "व्यक्तित्व",
    cat_personality_d: "Big-Five आधारित लक्षण",
    cat_aptitude: "योग्यता",
    cat_aptitude_d: "तर्क, भाषा और गणित",
    cat_interest: "रुचि (RIASEC)",
    cat_interest_d: "जो करना पसंद है",
    cat_mental: "मानसिक क्षमता",
    cat_mental_d: "स्मरण और पैटर्न पहचान",
    section: "खंड",
    how_kicker: "कैसे काम करता है",
    how_h2: "तीन आसान चरण।",
    how1_t: "ईमानदारी से उत्तर दें",
    how1_d: "4 आयामों पर लगभग 10-मिनट का मिश्रित मूल्यांकन।",
    how2_t: "AI विश्लेषण करता है",
    how2_d: "हमारा AI आपके पैटर्न और लक्षण पढ़कर आपके लिए मार्ग तैयार करता है।",
    how3_t: "अपना रास्ता पाएं",
    how3_d: "करियर, ताक़तें, विषय चुनाव और 3-चरणीय रोडमैप।",
    partners_kicker: "हमारे साझेदार",
    partners_h2: "अग्रणी संस्थानों का भरोसा",
    footer_copy: "छात्रों के लिए, शिक्षकों द्वारा।",
    footer_care: "प्रेम से बनाया गया",
  },
  pa: {
    login: "ਲੌਗਇਨ", get_started: "ਸ਼ੁਰੂ ਕਰੋ", logout: "ਲੌਗਆਊਟ",
    dashboard: "ਡੈਸ਼ਬੋਰਡ", assessment: "ਮੁਲਾਂਕਣ", vocational: "ਵੋਕੇਸ਼ਨਲ",
    my_children: "ਮੇਰੇ ਬੱਚੇ", school_overview: "ਸਕੂਲ ਸੰਖੇਪ",
    students: "ਵਿਦਿਆਰਥੀ", bulk_upload: "ਬਲਕ ਅੱਪਲੋਡ", class_report: "ਕਲਾਸ ਰਿਪੋਰਟ",
    school_dashboard: "ਸਕੂਲ ਡੈਸ਼ਬੋਰਡ", admin: "ਐਡਮਿਨ", questions: "ਪ੍ਰਸ਼ਨ",
    results: "ਨਤੀਜੇ",
    start_assessment: "ਮੁਲਾਂਕਣ ਸ਼ੁਰੂ ਕਰੋ", retake_assessment: "ਦੁਬਾਰਾ ਲਵੋ",
    hi_greeting: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ", class_: "ਜਮਾਤ", board: "ਬੋਰਡ", school: "ਸਕੂਲ",
    take_assessment_title: "ਆਪਣਾ ਕੈਰੀਅਰ ਮੁਲਾਂਕਣ ਲਵੋ",
    retake_title: "ਆਪਣਾ ਮੁਲਾਂਕਣ ਦੁਬਾਰਾ ਲਵੋ",
    past_reports: "ਪੁਰਾਣੀਆਂ ਰਿਪੋਰਟਾਂ", your_history: "ਤੁਹਾਡਾ ਇਤਿਹਾਸ",
    no_assessments: "ਹਾਲੇ ਕੋਈ ਮੁਲਾਂਕਣ ਨਹੀਂ। ਉੱਪਰੋਂ ਸ਼ੁਰੂ ਕਰੋ!",
    what_youll_get: "ਤੁਹਾਨੂੰ ਕੀ ਮਿਲੇਗਾ (NEP-ਅਨੁਕੂਲ)",
    save_pdf: "PDF ਸੇਵ ਕਰੋ",
    top_careers: "ਤੁਹਾਡੇ ਲਈ ਢੁਕਵੇਂ ਕੈਰੀਅਰ",
    ai_career_report: "AI ਕੈਰੀਅਰ ਰਿਪੋਰਟ",
    explore_career: "ਕੈਰੀਅਰ ਵੇਖੋ",
    print_report: "ਪ੍ਰਿੰਟ / PDF",
    recommended_stream: "ਸਿਫਾਰਸ਼ੀ ਸਟ੍ਰੀਮ",
    language: "ਭਾਸ਼ਾ",
    // Landing
    hero_tag: "AI-ਆਧਾਰਿਤ ਕੈਰੀਅਰ ਗਾਈਡ",
    hero_h1a: "ਉਹ ਕੈਰੀਅਰ ਲੱਭੋ",
    hero_h1b: "ਜੋ ਤੁਹਾਡੇ ਲਈ ਬਣਿਆ ਹੈ",
    hero_h1c: "— AI ਦੁਆਰਾ ਸੰਚਾਲਿਤ",
    hero_desc: "ਸਕੂਲੀ ਵਿਦਿਆਰਥੀਆਂ ਲਈ ਇੱਕ ਦੋਸਤਾਨਾ ਸਾਈਕੋਮੈਟ੍ਰਿਕ ਮੁਲਾਂਕਣ। ਸ਼ਖਸੀਅਤ, ਯੋਗਤਾ, ਰੁਚੀ ਅਤੇ ਮਾਨਸਿਕ ਸਮਰੱਥਾ ਬਾਰੇ ਈਮਾਨਦਾਰ ਸਵਾਲਾਂ ਦਾ ਜਵਾਬ ਦਿਓ — PathfinderAiClub ਦਾ AI ਇਹ ਸਭ ਵਿਸ਼ਲੇਸ਼ਣ ਕਰਕੇ ਤੁਹਾਡੇ ਲਈ ਸਭ ਤੋਂ ਢੁਕਵੇਂ ਕੈਰੀਅਰ ਰਾਹ ਦਿਖਾਉਂਦਾ ਹੈ।",
    hero_cta_primary: "ਆਪਣਾ ਬੈਸਟ-ਫਿੱਟ ਕਰੀਅਰ ਜਾਣੋ",
    hero_cta_secondary: "ਮੇਰਾ ਖਾਤਾ ਪਹਿਲਾਂ ਹੀ ਹੈ",
    hero_badge_private: "ਨਿੱਜੀ ਅਤੇ ਸੁਰੱਖਿਅਤ",
    hero_badge_grades: "ਜਮਾਤ 8–12 ਲਈ",
    hero_image_caption: "ਭਾਰਤ ਲਈ ਬਣਿਆ · CBSE, ICSE, PSEB ਤੇ State ਬੋਰਡ",
    nep_kicker: "ਇਹ ਕਿਉਂ ਜ਼ਰੂਰੀ ਹੈ · NEP 2020",
    nep_h2a: "ਭਾਰਤ ਦੀ ਰਾਸ਼ਟਰੀ ਸਿੱਖਿਆ ਨੀਤੀ ਕਹਿੰਦੀ ਹੈ ਕਿ",
    nep_h2b: "ਹਰ ਵਿਦਿਆਰਥੀ",
    nep_h2c: "ਆਪਣਾ ਰਾਹ ਖੁਦ ਚੁਣੇ",
    nep_desc: "NEP 2020 ਨੇ ਸਾਇੰਸ / ਕਾਮਰਸ / ਆਰਟਸ ਦੀ ਪੁਰਾਣੀ ਸਖ਼ਤ ਵੰਡ ਤੋੜ ਦਿੱਤੀ ਹੈ। ਹੁਣ ਵਿਦਿਆਰਥੀ ਵੱਖ-ਵੱਖ ਧਾਰਾਵਾਂ ਦੇ ਵਿਸ਼ੇ ਰਲਾ ਕੇ ਪੜ੍ਹ ਸਕਦੇ ਹਨ, ਜਮਾਤ 6 ਤੋਂ ਵੋਕੇਸ਼ਨਲ ਕੋਰਸ ਲੈ ਸਕਦੇ ਹਨ, ਅਤੇ ਆਪਣੀ ਰੁਚੀ ਅਤੇ ਤਾਕਤ ਅਨੁਸਾਰ ਵਿਸ਼ੇ ਚੁਣ ਸਕਦੇ ਹਨ। ਪਰ ਇਸ ਆਜ਼ਾਦੀ ਨੂੰ ਦਿਸ਼ਾ ਦੇਣ ਲਈ ਇੱਕ ਕੰਪਾਸ ਚਾਹੀਦਾ ਹੈ — ਇਹੀ PathfinderAiClub ਦਿੰਦਾ ਹੈ।",
    nep_pillar1_t: "ਬਹੁ-ਵਿਸ਼ਾਈ ਸਿੱਖਿਆ (§ 4.9)",
    nep_pillar1_d: "ਕੋਈ ਵੀ ਵਿਦਿਆਰਥੀ, ਕੋਈ ਵੀ ਧਾਰਾ — ਵਿਸ਼ੇ ਟੈਗ ਦੀ ਥਾਂ ਯੋਗਤਾ ਤੋਂ ਚੁਣੋ।",
    nep_pillar2_t: "ਜਮਾਤ 6 ਤੋਂ ਵੋਕੇਸ਼ਨਲ ਅਨੁਭਵ",
    nep_pillar2_d: "ਹਰ ਬੱਚੇ ਨੂੰ ਅਸਲੀ ਹੁਨਰ ਜਾਂ ਇੰਟਰਨਸ਼ਿਪ ਦਾ ਸੁਆਦ।",
    nep_pillar3_t: "ਜਮਾਤ 11-12 ਵਿੱਚ ਚੋਣ-ਅਧਾਰਿਤ ਵਿਸ਼ੇ",
    nep_pillar3_d: "ਫਿਜ਼ਿਕਸ ਨਾਲ ਲਲਿਤ ਕਲਾ, ਬਾਇਓ ਨਾਲ ਉੱਦਮਿਤਾ।",
    nep_pillar4_t: "ਇੱਕ ਤੋਂ ਵੱਧ ਪ੍ਰਵੇਸ਼ / ਨਿਕਾਸ ਬਿੰਦੂ",
    nep_pillar4_d: "ਕੋਈ ਇੱਕ 'ਗਲਤ' ਫੈਸਲਾ ਨਹੀਂ — ਹਰ ਪੜਾਅ 'ਤੇ ਵਾਪਸ ਜੁੜਨ ਦਾ ਰਾਹ।",
    nep_how_kicker: "PathfinderAiClub ਕਿਵੇਂ ਮਦਦ ਕਰਦਾ ਹੈ",
    nep_how_desc: "ਸਾਡਾ AI ਵਿਦਿਆਰਥੀ ਦੇ ਸਾਈਕੋਮੈਟ੍ਰਿਕ, ਯੋਗਤਾ, ਰੁਚੀ (RIASEC) ਅਤੇ ਮਾਨਸਿਕ ਸਮਰੱਥਾ ਦੇ ਸੰਕੇਤ ਪੜ੍ਹਦਾ ਹੈ — ਫਿਰ ਉਸ ਦੀ ਜਮਾਤ, ਬੋਰਡ (CBSE / ICSE / PSEB / State / IB) ਅਤੇ NEP ਪੜਾਅ ਅਨੁਸਾਰ ਇੱਕ ਰਿਪੋਰਟ ਬਣਾਉਂਦਾ ਹੈ। ਕਿਸੇ ਬੱਚੇ ਨੂੰ ਇੱਕ ਧਾਰਾ ਵਿੱਚ ਧੱਕਿਆ ਨਹੀਂ ਜਾਂਦਾ। ਉਹਨਾਂ ਨੂੰ 3 ਢੁਕਵੇਂ ਕੈਰੀਅਰ, ਦਰਵਾਜ਼ੇ ਖੋਲ੍ਹਣ ਵਾਲਾ ਵਿਸ਼ਾ-ਮਿਸ਼ਰਣ ਅਤੇ Now-Next-Beyond ਰੋਡਮੈਪ ਮਿਲਦਾ ਹੈ — ਕਾਊਂਸਲਰ, ਮਾਪੇ ਤੇ ਪ੍ਰਿੰਸੀਪਲ ਸਭ ਸ਼ਾਮਿਲ।",
    nep_image_caption: "ਸਿੱਖਿਆ ਮੰਤਰਾਲੇ, ਭਾਰਤ ਸਰਕਾਰ ਨਾਲ ਅਨੁਕੂਲ",
    cats_kicker: "ਅਸੀਂ ਕੀ ਮਾਪਦੇ ਹਾਂ",
    cats_h2: "4 ਪਹਿਲੂ। 1 AI ਰਿਪੋਰਟ।",
    cat_personality: "ਸ਼ਖਸੀਅਤ",
    cat_personality_d: "Big-Five ਆਧਾਰਿਤ ਗੁਣ",
    cat_aptitude: "ਯੋਗਤਾ",
    cat_aptitude_d: "ਤਰਕ, ਭਾਸ਼ਾ ਤੇ ਗਣਿਤ",
    cat_interest: "ਰੁਚੀ (RIASEC)",
    cat_interest_d: "ਜੋ ਕਰਨਾ ਪਸੰਦ ਹੈ",
    cat_mental: "ਮਾਨਸਿਕ ਸਮਰੱਥਾ",
    cat_mental_d: "ਯਾਦ ਤੇ ਪੈਟਰਨ ਪਛਾਣ",
    section: "ਭਾਗ",
    how_kicker: "ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ",
    how_h2: "ਤਿੰਨ ਸੌਖੇ ਕਦਮ।",
    how1_t: "ਈਮਾਨਦਾਰੀ ਨਾਲ ਜਵਾਬ ਦਿਓ",
    how1_d: "4 ਪਹਿਲੂਆਂ 'ਤੇ ਲਗਭਗ 10-ਮਿੰਟ ਦਾ ਮਿਸ਼ਰਿਤ ਮੁਲਾਂਕਣ।",
    how2_t: "AI ਵਿਸ਼ਲੇਸ਼ਣ ਕਰਦਾ ਹੈ",
    how2_d: "ਸਾਡਾ AI ਤੁਹਾਡੇ ਪੈਟਰਨ ਤੇ ਗੁਣ ਪੜ੍ਹ ਕੇ ਤੁਹਾਡੇ ਲਈ ਰਾਹ ਬਣਾਉਂਦਾ ਹੈ।",
    how3_t: "ਆਪਣਾ ਰਾਹ ਪਾਓ",
    how3_d: "ਕੈਰੀਅਰ, ਤਾਕਤਾਂ, ਵਿਸ਼ੇ ਦੀ ਚੋਣ ਅਤੇ 3-ਪੜਾਵੀ ਰੋਡਮੈਪ।",
    partners_kicker: "ਸਾਡੇ ਭਾਈਵਾਲ",
    partners_h2: "ਪ੍ਰਮੁੱਖ ਸੰਸਥਾਵਾਂ ਦਾ ਭਰੋਸਾ",
    footer_copy: "ਵਿਦਿਆਰਥੀਆਂ ਲਈ, ਸਿੱਖਿਅਕਾਂ ਵੱਲੋਂ।",
    footer_care: "ਪ੍ਰੇਮ ਨਾਲ ਬਣਾਇਆ ਗਿਆ",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("pf_lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (c) => {
    localStorage.setItem("pf_lang", c);
    setLangState(c);
  };

  const t = (key) => STRINGS[lang]?.[key] || STRINGS.en[key] || key;

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
